/**
 * Text the way the app's searches compare it: lower case and without diacritics, so "prishtine"
 * finds "Prishtinë", "korce" finds "Korçë" and "kepuce" finds "Këpucë" — most people type without
 * ë and ç.
 */
export const searchKey = (text: unknown) =>
	String(text ?? "")
		.normalize("NFD")
		.replace(/[\u0300-\u036f]/g, "")
		.toLowerCase();
